import { FormStore } from "../store/form.store";

const attachAnswersToForm = (formJson, answerResponse) => {
  const answersById = {};
  const notesById = {};
  (answerResponse.children || []).forEach((child) => {
    const id = child.id || child.elementId;
    const { componentType, answer } = child;
    const isNoSQL = FormStore.sharedInstance().getIsNoSQLForm();

    if (Array.isArray(child?.notes)) {
      notesById[id] = child.notes;
    } else if (typeof child?.notes === "string") {
      try {
        notesById[id] = JSON.parse(child.notes);
      } catch (err) {
        console.warn(
          `Invalid notes JSON in answer for id ${child.id || child.elementId}`,
          err,
        );
      }
    } else if (Array.isArray(child?.reviewerComments)) {
      notesById[id] = child.reviewerComments;
    }

    try {
      if (componentType == "fileInput" && isNoSQL) {
        answersById[id] = answer;
        return;
      }

      if (typeof answer === "string") {
        answersById[id] = JSON.parse(answer);
      } else {
        answersById[id] = answer;
      }
    } catch (err) {
      console.warn(
        `Invalid JSON in answer for id ${child.id || child.elementId}`,
        err,
      );
    }
  });

  function walkAndAttach(element) {
    const newElement = { ...element };

    if (answersById[element.id || element.elementId]) {
      newElement.answer = answersById[element.id || element.elementId];
    }

    if (notesById[element.id || element.elementId]) {
      newElement.notes = notesById[element.id || element.elementId];
    }

    if (Array.isArray(element.children)) {
      newElement.children = element.children.map(walkAndAttach);
    }

    return newElement;
  }

  const mergedForm = { ...formJson };
  for (const key in answerResponse) {
    if (key === "children") continue;
    if (!(key in formJson)) {
      mergedForm[key] = answerResponse[key];
    } else if (answerResponse[key] !== null) {
      mergedForm[key] = answerResponse[key];
    }
  }

  mergedForm.children = (formJson.children || []).map(walkAndAttach);
  return mergedForm;
};

export default attachAnswersToForm;

export const hydrateAnswers = (answers) => {
  const isNoSQL = FormStore.sharedInstance().getIsNoSQLForm();
  answers?.children?.forEach((child) => {
    if (child?.componentType == "fileInput" && isNoSQL) {
      return;
    }
    if (typeof child?.answer === "string") {
      child.answer = JSON.parse(child?.answer);
    }
  });
  return answers;
};

const BLOCKED_NUMERIC_INPUT_KEYS = ["e", "E", "+", "-", "."];
export const blockExponentialNumericInput = (event) => {
  if (event && BLOCKED_NUMERIC_INPUT_KEYS.includes(event.key)) {
    event.preventDefault();
  }
};
